const s = {
  card: {
    background: "#fff",
    border: "1px solid rgba(224, 224, 200, 1)",
    borderRadius: 4,
    padding: "32px 40px 40px",
    width: "100%",
    maxWidth: 370,
    margin: "7rem auto",
    boxSizing: "border-box",
    paddingBottom:120,
  },
  title: {
    fontSize: 22,
    fontWeight: 1000,
    color: "#000",
    marginBottom: 6,
  },
  subtitle: {
    fontSize: 12,
    color: "#000",
    marginBottom: 20,
  },
  label: {
    display: "block",
    fontSize: 14,
    color: "#000",
    marginBottom: 4,
    marginTop: 16,
  },
  hint: {
    fontSize: 12,
    color: "#555",
    marginTop: 4,
    marginBottom: 0,
  },
  input: {
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: 4,
    padding: "10px 12px",
    fontSize: 15,
    color: "#000",
    outline: "none",
    boxSizing: "border-box",
  },
  inputWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  showBtn: {
    position: "absolute",
    right: 12,
    background: "none",
    border: "none",
    color: "#000",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
    padding: 0,
  },
  forgotRow: {
    textAlign: "right",
    marginTop: 8,
    marginBottom: 8,
  },
  rememberRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 12,
    marginBottom: 16,
    fontSize: 14,
  },
  checkLabel: {
    display: "flex",
    alignItems: "center",
    fontSize: 12,
    color: "#000",
    cursor: "pointer",
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    fontSize: 12,
    color: "#000",
    cursor: "pointer",
  },
  link: {
    color: "#000",
    textDecoration: "underline",
    cursor: "pointer",
    fontSize: 12,
  },
  editLink: {
    color: "#000",
    textDecoration: "underline",
    cursor: "pointer",
    fontSize: 12,
    display: "block",
    marginTop: 2,
  },
  youEntered: {
    fontSize: 12,
    color: "#555",
    marginBottom: 2,
    marginTop: 16,
  },
  enteredValue: {
    fontSize: 16,
    color: "#000",
    fontWeight: 400,
    marginBottom: 2,
  },
  btnActive: {
    display: "block",
    width: "100%",
    background: "#000",
    color: "#fff",
    border: "none",
    borderRadius: 400,
    padding: "13px 0",
    fontSize: 16,
    fontWeight: 700,
    cursor: "pointer",
    marginTop: 24,
    letterSpacing: 0.2,
  },
  btnDisabled: {
    display: "block",
    width: "100%",
    background: "#d8d8d8",
    color: "#fff",
    border: "none",
    borderRadius: 400,
    padding: "13px 0",
    fontSize: 16,
    fontWeight: 700,
    cursor: "not-allowed",
    marginTop: 24,
  },
  botReply: {
    background: "#f0f7ff",
    border: "1px solid #cce0ff",
    borderRadius: 4,
    padding: "10px 14px",
    marginTop: 16,
    marginBottom: 4,
  },
  botReplyText: {
    fontSize: 14,
    color: "#003d99",
    margin: 0,
    whiteSpace: "pre-wrap",
  },
  warningDiv: {
    background: "#fbe4d7",
    border: "1px solid #f4b8a0",
    borderRadius: 4,
    padding: "14px 18px",
    margin: "16px auto",
    maxWidth: "80%",
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    textAlign: "left",
    justifyContent: "center",
  },
  warningIcon: {
    fontSize: 18,
    alignSelf: "center",
  },
  warningTextHead: {
    fontSize: 16,
    color: "#000",
    margin: 0,
    lineHeight: 1.5,
    fontWeight:"600"
  },
  warningText: {
    fontSize: 14,
    color: "#000",
    margin: 0,
    lineHeight: 1.5,
  },
  warningLink: {
    color: "#000",
    textDecoration: "underline",
    cursor: "pointer",
  },
};

export default s;
